import React from 'react';

import NhiCustomInsight from './NhiCustomInsight';
import OwnersConfig from './OwnersConfig';

export interface OnPremProps {
    saveCustomInsights: () => void;
    saveOwnersSyncConfig: () => void;
    fields: any;
    dispatch: React.Dispatch<any>;
}

const OnPrem: React.FC<OnPremProps> = React.memo(({ saveCustomInsights, saveOwnersSyncConfig, fields, dispatch }) => {
    return (
        <div className="flex flex-col gap-8">
            <div>
                <NhiCustomInsight save={saveCustomInsights} dispatch={dispatch} fields={fields} />
            </div>
            <div>
                <OwnersConfig save={saveOwnersSyncConfig} dispatch={dispatch} fields={fields} />
            </div>
        </div>
    );
});

export default OnPrem;
